exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.dataTable tbody td[data-v-205f4100] {\n    word-break: break-word;\n    word-break: break-all;\n    white-space: normal;\n}\n", ""]);

// exports
